import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcWorkspaceFilesUserStatusListCurrentUserWarning]'
})
export class WorkspaceFilesUserStatusListCurrentUserWarningDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
